import { render, staticRenderFns } from "./MedicareNumber.vue?vue&type=template&id=47d32f83"
import script from "./MedicareNumber.vue?vue&type=script&lang=js"
export * from "./MedicareNumber.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports